<template>
    <el-button type="primary" :disabled="count>0 || disabled" :loading="loading" @click="submitForm('ruleForm')" size="small">
        {{loading ? '请稍后...' : count ? `${btnText}(${count})` : btnText}}
    </el-button>
</template>

<script>
    import Vue, { Component } from 'C/BaseVue'
    @Component({
        props: {
            pLoading : {
                type: Boolean,
                default: () => { return false }
            },
            text : {
                type: String,
                default: () => { return '' }
            },
            disabled: {
                type: Boolean,
                default: () => { return false }
            },
            countdown: {
                type: Number,
                default: () => { return 0 }
            }
        },
        watch: {
            pLoading : {
                handler(curVal, oldVal){
                    this.loading = curVal
                },
                immediate: true
            },
            text: {
                handler(curVal, oldVal){
                    this.btnText = curVal || '提 交'
                },
                immediate: true
            },
            countdown: {
                handler(curVal, oldVal){
                    this.count = curVal
                    if (curVal && !this.timer) {
                        this.timer = setInterval(() => {
                            if (this.count > 0) {
                                this.count--;
                            } else {
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                },
                immediate: true
            }
        },
        data(){
            return {
                loading: false,
                btnText: '提 交',
                timer: null,
                count: 0
            }
        }
    })
    export default class LoadingButton extends Vue {
        mounted(){
            if(this.text){
                this.btnText = this.text
            }
        }
        submitForm(){
            this.$emit('update:pLoading',true)
            this.$emit('callback')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/LoadingButton.vue